<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-4">
        a) What is the ground state electron configuration for the
        <chemical-latex :content="atom1" /> atom?
      </p>

      <electron-configuration-input
        v-model="inputs.electronConfig1"
        :max-n="5"
        :max-occupation="10"
        :orbital-types="['s', 'p', 'd']"
      />

      <p class="mb-4">
        b) What is the ground state electron configuration for the
        <chemical-latex :content="atom2" /> atom?
      </p>

      <electron-configuration-input
        v-model="inputs.electronConfig2"
        :max-n="5"
        :max-occupation="10"
        :orbital-types="['s', 'p', 'd']"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import ElectronConfigurationInput from '../inputs/ElectronConfigurationInput';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'Question548',
  components: {
    ChemicalLatex,
    ElectronConfigurationInput,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking
      inputs: {
        electronConfig1: [],
        electronConfig2: [],
      },
    };
  },
  computed: {
    versionNumber() {
      return this.taskState.getValueBySymbol('versionNumber').content;
    },
    // ecVersion
    atom1() {
      if (this.versionNumber.value === 1) {
        return 'Mn';
      } else if (this.versionNumber.value === 2) {
        return 'Zn';
      } else if (this.versionNumber.value === 3) {
        return 'Tc';
      } else if (this.versionNumber.value === 4) {
        return 'Cd';
      } else {
        return '***ERROR. Please contact support@stemble.com***';
      }
    },
    atom2() {
      if (this.versionNumber.value === 1) {
        return 'Cr';
      } else if (this.versionNumber.value === 2) {
        return 'Cu';
      } else if (this.versionNumber.value === 3) {
        return 'Mo';
      } else if (this.versionNumber.value === 4) {
        return 'Ag';
      } else {
        return '***ERROR. Please contact support@stemble.com***';
      }
    },
  },
};
</script>
